const PROCEDIMENTOS_CONSULTA = [1, 58, 800];

const isEcg = atividade => atividade.CODPROCEDI === 3;

export const isAtividadeConsulta = atividade =>
  PROCEDIMENTOS_CONSULTA.includes(Number(atividade?.CODPROCEDI));

export const isAtividadeEcg = atividade => Number(atividade?.CODPROCEDI) === 3;

const atividadeParaFatura = atividade => ({
  codFatura: atividade.CODFATURA,
  codLaudo: atividade.CODLAUDO,
  codPac: atividade.CODPAC,
  paciente: atividade.NOMEPAC,
  codConveniado: atividade.CODMEDICO,
  codSolicitou: atividade.CODENCAMINHOU,
  codFaturou: atividade.CODFATUROU || atividade.CODFATURAMENTO,
  codRealizou: atividade.CODREALIZOU,
  conveniado: atividade.NOMEMED,
  solicitou: atividade.ENCAMINHOU,
  faturou: atividade.FATUROU,
  realizou: atividade.REALIZOU,
  codProcedi: atividade.CODPROCEDI,
  procedimento: atividade.DESCPROCEDI,
  codConv: atividade.CODCONV,
  convenio: atividade.SIGLACONV,
  valor: atividade.VLRLAUDO,
  guia: isEcg(atividade) ? '' : atividade.GUIA,
  guiaecg: isEcg(atividade) ? atividade.GUIA : '',
  qtdFetos: 1,
});

export default atividadeParaFatura;
